import {BASE_URL, STATUS_SUCCESS, STATUS_ERROR} from "../../utility/Constants";
import {useApiCalls} from "../../hooks/useApiCalls";
import {STRIPE_PK_KEY} from "../../utility/StripeSettings";
import {useAlertContext} from "../../context/AlertContext";
import {useUser} from "../../context/UserContext";
import {useState,useEffect} from "react";
import {loadStripe} from "@stripe/stripe-js";
import { 
    Spinner,
    Container,
    Center
 } from "@chakra-ui/react"


/**
 * call api to create order and get Stripe payment - client secret key
 * display Stripe paynow QR
 */
function WalletPaymentPaynow(props){

    const {authorizationToken,removeUser} = useUser();
    const {onOpen} = useAlertContext();

    const [stripe, setStripe]  = useState(null);

    const amount = props.amount;

    const [paymentIntentId, setPaymentIntentId] = useState(null);
    const [clientSecret, setClientSecret] = useState(null);
    const [walletPaymentId, setWalletPaymentId] = useState(null);

    const [handleAddWalletPaymentApiCall,isLoadingAddWalletPayment, dataAddWalletPayment, errorAddWalletPayment] = useApiCalls();

    const TITLE_ERROR_ADD_WALLET_PAYMENT="Error when create a new wallet payment !";
    const TITLE_SUCCESSFUL_ADD_WALLET_PAYMENT="Payment Successful !";
    const DESCRIPTION_SUCCESSFUL_ADD_WALLET_PAYMENT="Wallet Recharge Successful.";

    const POST_ADD_WALLET_PAYMENT_URL = BASE_URL+ "/api/v1/wallet/create_wallet_payment_paynow";


    useEffect(()=>{

        if(clientSecret===null){
            //1) get stripe secret key
            submitAddWalletPayment();
        }

    },[]);


    useEffect(()=>{

        if(clientSecret!==null && stripe!==null){
            //2) call stripe paynow payment
            submitStripePaynow();
        }

    },[clientSecret,stripe]);


    useEffect(()=>{

        if(stripe===null){

            const stripe = loadStripe(STRIPE_PK_KEY);
            stripe.then((value)=>setStripe(value)); //resolve promise obj
        }

    },[stripe]);


    useEffect(()=>{

        if(dataAddWalletPayment!==null){

            if(dataAddWalletPayment.content.status==="successful"){
                setClientSecret(dataAddWalletPayment.content.client_secret);
                setWalletPaymentId(dataAddWalletPayment.content.wallet_payment_id);
                setPaymentIntentId(dataAddWalletPayment.content.payment_intent_id);
            }

        }

    },[dataAddWalletPayment])


    useEffect(()=>{

        if(errorAddWalletPayment!==null){
            props.handleSetPaymentStatus(false);

            if(errorAddWalletPayment==="unauthorized_access"){
                onOpen(STATUS_ERROR,TITLE_ERROR_ADD_WALLET_PAYMENT,"Login expired, please login again");
                removeUser();
            }else{
                onOpen(STATUS_ERROR,TITLE_ERROR_ADD_WALLET_PAYMENT, errorAddWalletPayment);
            }
        }

    },[errorAddWalletPayment])


     //api calls add single item order
     const submitAddWalletPayment = ()=>{

        //headers
        const config = {
            headers:{
                "Authorization": `Bearer ${authorizationToken}`,
                "Content-Type": "application/json"
            }
        };

         //body json params
         const apiJsonParams = {
            amount: amount
        };

        const apiCalls ={
            apiConfig: config,
            url: POST_ADD_WALLET_PAYMENT_URL,
            apiType: "post",
            apiJsonParams: apiJsonParams
        }

        handleAddWalletPaymentApiCall({apiCalls});//call api
    }
    //end add single item order


    function submitStripePaynow(){

        stripe.confirmPayNowPayment(
            clientSecret
          )
          .then((res) => {
            if(res.paymentIntent.status === "succeeded") {

              // The user scanned the QR code
              props.handleSetPaymentStatus(true);
              //update backend payment success if window not closed
              //updateStripeOrderPayment();
              onOpen(STATUS_SUCCESS, TITLE_SUCCESSFUL_ADD_WALLET_PAYMENT, DESCRIPTION_SUCCESSFUL_ADD_WALLET_PAYMENT);

            } else {

              // The user closed the modal, cancelling payment
              //console.log("The user closed the modal, cancelling payment");
              props.handleSetPaymentStatus(false);

             // if(res.paymentIntent.status==="requires_action"){
            //    onOpen(STATUS_ERROR,"Payment Failed !","Payment not received !");
            //  }else{
                //onOpen(STATUS_ERROR,"Payment Failed !",res.paymentIntent.status);
                //go back to reload home?
            //  }

            }
        })
        .catch(function (error) {
            //console.log("error: "+error);
            onOpen(STATUS_ERROR,`An error has occured ! (${error})`,"Please check wallet balance for confirmation, before recharge again !");
        })

    }


    return(

        <Container minWidth={{ base: "200px",sm: "350px", md: "400px"}}  maxWidth={400}  borderWidth={0} borderColor={"blue"}  borderRadius={8} boxShadow="lg">
            <Center p={3}><Spinner size="xl"/> <p>Processing order...Please wait...</p></Center>
        </Container>

    );

}
export default WalletPaymentPaynow;